import { EventBus } from "../../../infrastructure/commons/eventBus/eventBus";
import { TYPE_TAG } from "./form/tags/interface/typeTag";
const LocationInputsHandler = ({ setSelectedReturnLocation, setShowBack, onHandleTagShowKey }) => {
    let isLoading = false;
    EventBus.getInstance().on("ShowLoadingModal", (data) => {
        var show = data.noResultstate || data.isLoading ? false : true;
        isLoading = show;
    });
    const handleClick = (e) => {
        const filterSwitch1 = document.querySelector("#filter-switch-1");
        const filterSwitch = document.querySelector("#filter-switch");
        const filterSwitchEX = document.querySelector("#filter-switch-ex");
        if (filterSwitch1 === null || filterSwitch1 === void 0 ? void 0 : filterSwitch1.checked) {
            filterSwitch1.checked = false;
            filterSwitch.checked = false;
            if (filterSwitchEX) {
                filterSwitchEX.checked = false;
            }
        }
        if (filterSwitch === null || filterSwitch === void 0 ? void 0 : filterSwitch.checked) {
            filterSwitch.checked = false;
            filterSwitch1.checked = false;
            if (filterSwitchEX) {
                filterSwitchEX.checked = false;
            }
        }
    };
    document.addEventListener("click", handleClick);
    const dropdownFilterSelected1 = document.querySelector('[for="filter-switch-1"] .dropdown__filter-selected');
    dropdownFilterSelected1 === null || dropdownFilterSelected1 === void 0 ? void 0 : dropdownFilterSelected1.addEventListener("input", (e) => {
        const filterSwitch1 = document.querySelector("#filter-switch-1");
        const inputValue1 = e.target.value;
        if (filterSwitch1 && inputValue1.length > 2) {
            filterSwitch1.checked = true;
        }
    });
    const dropdownFilterSelected = document.querySelector('[for="filter-switch"] .dropdown__filter-selected');
    dropdownFilterSelected === null || dropdownFilterSelected === void 0 ? void 0 : dropdownFilterSelected.addEventListener("input", (e) => {
        const filterSwitch = document.querySelector("#filter-switch");
        const inputValue = e.target.value;
        if (filterSwitch && inputValue.length > 2) {
            filterSwitch.checked = true;
        }
    });
    const dropdownFilterSelectedEX = document.querySelector('[for="filter-switch-ex"] .dropdown__filter-selected');
    dropdownFilterSelectedEX === null || dropdownFilterSelectedEX === void 0 ? void 0 : dropdownFilterSelectedEX.addEventListener("input", (e) => {
        const filterSwitchEX = document.querySelector("#filter-switch-ex");
        const inputValue = e.target.value;
        if (filterSwitchEX && inputValue.length > 2) {
            filterSwitchEX.checked = true;
        }
    });
    const filterSwitch1Options = document.querySelectorAll('[for="filter-switch-1"] .dropdown__select-option');
    filterSwitch1Options === null || filterSwitch1Options === void 0 ? void 0 : filterSwitch1Options.forEach((option) => {
        option.addEventListener("click", () => {
            const dropdownFilterSelected1 = document.querySelector('[for="filter-switch-1"] .dropdown__filter-selected');
            if (dropdownFilterSelected1) {
                dropdownFilterSelected1.value = option.textContent || "";
                dropdownFilterSelected1.classList.add("selected");
                setTimeout(function () {
                    var _a, _b, _c, _d;
                    const filterSwitch1 = document.querySelector("#filter-switch-1");
                    if (filterSwitch1) {
                        filterSwitch1.checked = false;
                        (_a = document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.classList.remove("noscroll");
                        (_b = document.querySelector(".search_bg")) === null || _b === void 0 ? void 0 : _b.classList.remove("open");
                        (_d = (_c = document.querySelector("#filter-switch-1")) === null || _c === void 0 ? void 0 : _c.closest(".search_col")) === null || _d === void 0 ? void 0 : _d.classList.remove("search_popup");
                    }
                }, 50);
            }
        });
    });
    const filterSwitchOptions = document.querySelectorAll('[for="filter-switch"] .dropdown__select-option');
    filterSwitchOptions === null || filterSwitchOptions === void 0 ? void 0 : filterSwitchOptions.forEach((option) => {
        option.addEventListener("click", () => {
            const dropdownFilterSelected = document.querySelector('[for="filter-switch"] .dropdown__filter-selected');
            if (dropdownFilterSelected) {
                dropdownFilterSelected.value = option.textContent || "";
                dropdownFilterSelected.classList.add("selected");
                setTimeout(function () {
                    var _a, _b, _c, _d, _e, _f;
                    const filterSwitch = document.querySelector("#filter-switch");
                    if (filterSwitch) {
                        filterSwitch.checked = false;
                        (_a = document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.classList.remove("noscroll");
                        (_b = document.querySelector(".search_bg")) === null || _b === void 0 ? void 0 : _b.classList.remove("open");
                        (_d = (_c = document.querySelector("#filter-switch")) === null || _c === void 0 ? void 0 : _c.closest(".search_col")) === null || _d === void 0 ? void 0 : _d.classList.remove("search_popup");
                        (_e = document.querySelector("#chat")) === null || _e === void 0 ? void 0 : _e.classList.remove("hidden");
                        (_f = document.querySelector(".localization-form")) === null || _f === void 0 ? void 0 : _f.classList.remove("hidden");
                    }
                }, 50);
            }
        });
    });
    const filterSwitchEXOptions = document.querySelectorAll('[for="filter-switch-ex"] .dropdown__select-option');
    filterSwitchEXOptions === null || filterSwitchEXOptions === void 0 ? void 0 : filterSwitchEXOptions.forEach((option) => {
        option.addEventListener("click", () => {
            const dropdownFilterSelectedEX = document.querySelector('[for="filter-switch-ex"] .dropdown__filter-selected');
            if (dropdownFilterSelectedEX) {
                dropdownFilterSelectedEX.value = option.textContent || "";
                dropdownFilterSelectedEX.classList.add("selected");
                setTimeout(function () {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                    const filterSwitchEX = document.querySelector("#filter-switch-ex");
                    if (filterSwitchEX) {
                        filterSwitchEX.checked = false;
                        (_a = document.querySelector("body")) === null || _a === void 0 ? void 0 : _a.classList.remove("noscroll");
                        (_b = document.querySelector(".modal-mobile")) === null || _b === void 0 ? void 0 : _b.classList.remove("show");
                        (_c = document.querySelector(".searchbar")) === null || _c === void 0 ? void 0 : _c.classList.remove("hidden");
                        (_d = document.querySelector("#chat")) === null || _d === void 0 ? void 0 : _d.classList.remove("hidden");
                        (_e = document.querySelector(".localization-form")) === null || _e === void 0 ? void 0 : _e.classList.remove("hidden");
                        (_f = document.querySelector(".search_bg")) === null || _f === void 0 ? void 0 : _f.classList.remove("open");
                        (_h = (_g = document.querySelector("#filter-switch-ex")) === null || _g === void 0 ? void 0 : _g.closest(".search_col")) === null || _h === void 0 ? void 0 : _h.classList.remove("search_popup");
                        (_j = document.querySelector(".right_side_logo")) === null || _j === void 0 ? void 0 : _j.classList.remove("hidden");
                        (_k = document.querySelector(".banner__content")) === null || _k === void 0 ? void 0 : _k.classList.remove("hidden");
                        (_l = document.querySelector(".header")) === null || _l === void 0 ? void 0 : _l.classList.remove("hidden");
                        (_m = document.querySelector(".both_background")) === null || _m === void 0 ? void 0 : _m.classList.remove("full");
                        (_o = document.querySelector("#search-bar")) === null || _o === void 0 ? void 0 : _o.setAttribute("style", "width: unset;");
                        (_p = document.querySelector(".header__icons")) === null || _p === void 0 ? void 0 : _p.classList.remove("hidden");
                        (_q = document.querySelector(".header__heading-logo-wrapper")) === null || _q === void 0 ? void 0 : _q.classList.remove("hidden");
                        (_r = document.querySelector(".modal-mobile")) === null || _r === void 0 ? void 0 : _r.classList.remove("opening");
                        (_s = document.querySelector("#help_label_chat")) === null || _s === void 0 ? void 0 : _s.classList.remove("hidden");
                        (_t = document
                            .querySelector(".section-header.shopify-section-group-header-group")) === null || _t === void 0 ? void 0 : _t.setAttribute("style", "z-index: 99 !important;");
                    }
                }, 50);
            }
        });
    });
    const styledCheckbox1 = document.querySelector('[for="styled-checkbox-1"]');
    styledCheckbox1 === null || styledCheckbox1 === void 0 ? void 0 : styledCheckbox1.addEventListener("click", (e) => {
        setTimeout(function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            const filterSwitch1 = document.querySelector("#filter-switch-1");
            const filterSwitch = document.querySelector("#filter-switch");
            const styledCheckbox1 = document.querySelector("#styled-checkbox-1");
            setSelectedReturnLocation(["", "", 0]);
            if (!styledCheckbox1.checked) {
                onHandleTagShowKey(TYPE_TAG.RECOMMENDED_LOCATIONS);
                (_b = (_a = document.querySelector(".return-location")) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.classList.add("hidden");
                (_d = (_c = document.querySelector(".pickup-location")) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.classList.add("only");
                (_f = (_e = document.querySelector(".searchbar")) === null || _e === void 0 ? void 0 : _e.parentElement) === null || _f === void 0 ? void 0 : _f.classList.remove("both_searchbar");
                (_g = document.querySelector(".right_logo_mobile")) === null || _g === void 0 ? void 0 : _g.classList.remove("both_trust");
                (_h = document.querySelector(".banner--content-align-left")) === null || _h === void 0 ? void 0 : _h.classList.remove("both_background");
                document.getElementsByClassName("dropdown__filter-selected")[0].classList.add("big_input");
                filterSwitch.checked = false;
                filterSwitch1.checked = false;
            }
            else {
                onHandleTagShowKey(TYPE_TAG.NONE);
                (_k = (_j = document.querySelector(".return-location")) === null || _j === void 0 ? void 0 : _j.parentElement) === null || _k === void 0 ? void 0 : _k.classList.remove("hidden");
                (_m = (_l = document.querySelector(".pickup-location")) === null || _l === void 0 ? void 0 : _l.parentElement) === null || _m === void 0 ? void 0 : _m.classList.remove("only");
                (_p = (_o = document.querySelector(".searchbar")) === null || _o === void 0 ? void 0 : _o.parentElement) === null || _p === void 0 ? void 0 : _p.classList.add("both_searchbar");
                (_q = document.querySelector(".right_logo_mobile")) === null || _q === void 0 ? void 0 : _q.classList.add("both_trust");
                (_r = document.querySelector(".banner--content-align-left")) === null || _r === void 0 ? void 0 : _r.classList.add("both_background");
                document.getElementsByClassName("dropdown__filter-selected")[0].classList.remove("big_input");
            }
        }, 50);
    });
    const styledCheckbox2 = document.querySelector('[for="styled-checkbox-2"]');
    styledCheckbox2 === null || styledCheckbox2 === void 0 ? void 0 : styledCheckbox2.addEventListener("click", (e) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const filterSwitch1 = document.querySelector("#filter-switch-1");
        const filterSwitch = document.querySelector("#filter-switch");
        const styledCheckbox2 = document.querySelector("#styled-checkbox-2");
        if (styledCheckbox2.checked) {
            onHandleTagShowKey(TYPE_TAG.RECOMMENDED_LOCATIONS);
            (_b = (_a = document.querySelector(".searchbar")) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove("both_searchbar");
            (_c = document.querySelector(".right_logo_mobile")) === null || _c === void 0 ? void 0 : _c.classList.remove("both_trust");
            (_e = (_d = document.querySelector("body")) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.classList.remove("double-check--return");
            (_f = document.querySelector(".banner--content-align-left")) === null || _f === void 0 ? void 0 : _f.classList.remove("both_background");
            filterSwitch.checked = false;
            filterSwitch1.checked = false;
            setSelectedReturnLocation(["", "", 0]);
        }
        else {
            onHandleTagShowKey(TYPE_TAG.NONE);
            (_h = (_g = document.querySelector(".searchbar")) === null || _g === void 0 ? void 0 : _g.parentElement) === null || _h === void 0 ? void 0 : _h.classList.add("both_searchbar");
            (_k = (_j = document.querySelector("body")) === null || _j === void 0 ? void 0 : _j.parentElement) === null || _k === void 0 ? void 0 : _k.classList.add("double-check--return");
            (_l = document.querySelector(".right_logo_mobile")) === null || _l === void 0 ? void 0 : _l.classList.add("both_trust");
            (_m = document.querySelector(".banner--content-align-left")) === null || _m === void 0 ? void 0 : _m.classList.add("both_background");
        }
    });
    let sticky = document.querySelector("sticky-header");
    const searchDetails = document.querySelector("#search_details");
    searchDetails === null || searchDetails === void 0 ? void 0 : searchDetails.addEventListener("click", (e) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // Check if the URL has the 'app' parameter
        // If it does, do not proceed with the fullscreen logic
        const urlParams = new URLSearchParams(window.location.search);
        const hasAppParam = urlParams.has('app');
        if (hasAppParam) {
            return;
        }
        setShowBack(true);
        if (sticky) {
            sticky.classList.add("sticky-fullscreen");
        }
        (_a = document.querySelector(".research_container")) === null || _a === void 0 ? void 0 : _a.classList.remove("hidden");
        (_b = document.querySelector(".header__heading-link")) === null || _b === void 0 ? void 0 : _b.classList.add("hidden");
        (_c = document.querySelector(".searchbar")) === null || _c === void 0 ? void 0 : _c.classList.add("show");
        searchDetails.classList.add("hidden");
        EventBus.getInstance().emit("ShowLoading", { value: false });
        (_d = document.querySelector("#loading-bar-container-up")) === null || _d === void 0 ? void 0 : _d.classList.add("hidden");
        (_e = document.querySelector("#loading-bar-container-up")) === null || _e === void 0 ? void 0 : _e.classList.add("hidden");
        (_f = document.querySelector("body")) === null || _f === void 0 ? void 0 : _f.classList.add("noscroll", "edit-fullscreen");
        (_g = document.querySelector("#blue-bar-searchbar")) === null || _g === void 0 ? void 0 : _g.setAttribute("style", "display: flex !important;");
        (_h = document.querySelector("#chat")) === null || _h === void 0 ? void 0 : _h.setAttribute("style", "display: none !important;");
    });
    const searchIcon = document.querySelector(".searchbar .serch_icon");
    searchIcon === null || searchIcon === void 0 ? void 0 : searchIcon.addEventListener("click", (e) => {
        var _a, _b, _c, _d, _e, _f;
        if (sticky) {
            sticky.classList.remove("sticky-fullscreen");
        }
        (_a = document.querySelector(".research_container")) === null || _a === void 0 ? void 0 : _a.classList.add("hidden");
        (_b = document.querySelector(".header__heading-link")) === null || _b === void 0 ? void 0 : _b.classList.remove("hidden");
        (_c = document.querySelector("body")) === null || _c === void 0 ? void 0 : _c.classList.remove("noscroll", "edit-fullscreen");
        (_d = document.querySelector(".searchbar")) === null || _d === void 0 ? void 0 : _d.classList.remove("show");
        searchDetails === null || searchDetails === void 0 ? void 0 : searchDetails.classList.remove("hidden");
        (_e = document.querySelector("#blue-bar-searchbar")) === null || _e === void 0 ? void 0 : _e.setAttribute("style", "display: none !important;");
        (_f = document.querySelector("#chat")) === null || _f === void 0 ? void 0 : _f.setAttribute("style", "display: flex !important;");
        setShowBack(false);
    });
    const hideShowBack = document.querySelector(".hide_search_bar");
    hideShowBack === null || hideShowBack === void 0 ? void 0 : hideShowBack.addEventListener("click", (e) => {
        var _a, _b, _c, _d, _e;
        if (sticky) {
            sticky.classList.remove("sticky-fullscreen");
        }
        (_a = document.querySelector(".research_container")) === null || _a === void 0 ? void 0 : _a.classList.add("hidden");
        (_b = document.querySelector(".header__heading-link")) === null || _b === void 0 ? void 0 : _b.classList.remove("hidden");
        (_c = document.querySelector("body")) === null || _c === void 0 ? void 0 : _c.classList.remove("noscroll");
        (_d = document.querySelector(".searchbar")) === null || _d === void 0 ? void 0 : _d.classList.remove("show");
        (_e = document.querySelector("#chat")) === null || _e === void 0 ? void 0 : _e.setAttribute("style", "display: flex !important;");
        searchDetails === null || searchDetails === void 0 ? void 0 : searchDetails.classList.remove("hidden");
        setShowBack(false);
    });
    const hideModalFullScreen = document.querySelector(".main-back-blue-bar");
    hideModalFullScreen === null || hideModalFullScreen === void 0 ? void 0 : hideModalFullScreen.addEventListener("click", (e) => {
        EventBus.getInstance().emit("ShowLoading", { value: isLoading });
        if (sticky) {
            sticky.classList.remove("sticky-fullscreen");
        }
    });
};
export default LocationInputsHandler;
